import { createContext } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const BadgesContext = createContext({
  previouslyPurchasedBadgeData: [],
  getPreviouslyPurchasedBadgeData: () => {},
  productId: {},
  isLoggedIn: false,
  isProductPurchasedPreviously: false,
  isQv: false,
});
